import { NameAvatar, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { getName } from '@hero/utils';

const StyledUserName = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;

  ${({ onClick }) => {
    return (
      !!onClick &&
      css`
        background: none;
        border: none;
        cursor: pointer;
        margin: 0;
        outline: none;
        padding: 0;
      `
    );
  }}
`;

export function UserName({
  firstName,
  lastName,
  onClick,
  as,
  to,
  style,
  hasNameAvatar = false,
  ...props
}) {
  const name = getName({ firstName, lastName });

  return (
    <StyledUserName
      onClick={onClick}
      style={style}
      {...(!!onClick && { as: 'button' })}
      {...(as ? { as } : {})}
      {...(to ? { to } : {})}
      {...props}
    >
      {hasNameAvatar && <NameAvatar name={name} />}
      <Typography variant="body2">{name}</Typography>
    </StyledUserName>
  );
}

UserName.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  as: PropTypes.elementType,
  to: PropTypes.string,
  style: PropTypes.object,
  hasNameAvatar: PropTypes.bool
};
